var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('sketch',{on:{"input":_vm.updateParent},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }